import {
  AQI_LEVELS_COLORS,
  AQI_LEVELS_LOWER_BOUNDS,
} from 'features/aqiSensors/aqiSensors.constants';
import { ColorStop } from 'features/mapping/mapping.types';

export const AQI_SOURCE_ID = 'aqi-stations';
export const AQI_SOURCE_LAYER = 'weatherstations_aqi';
export const AQI_SELECTED_POINT_ICON_LAYER_ID = 'aqi-selected-point-icon-layer';
export const AQI_SELECTED_POINT_ICON_MODERATE_OR_ABOVE_LAYER_ID =
  'aqi-selected-point-icon-moderate-or-above-layer';
export const AQI_POINT_ICONS_LAYER_ID = 'aqi-point-icons-layer';
export const AQI_POINT_BLURS_LAYER_ID = 'aqi-point-blurs-layer';
export const AQI_BASE_POINT_BLURS_LAYER_ID = 'aqi-base-point-blurs-layer';
export const AQI_LABELS_LAYER_ID = 'aqi-labels-layer';
export const AQI_POINT_ICONS_MODERATE_OR_ABOVE_LAYER_ID =
  'aqi-point-icons-moderate-or-above-layer';
export const BASE_PULSE_CIRCLE_RADIUS = 3;
export const MAX_ICON_INTERPOLATION_ZOOM_LEVEL = 13;
export const MIN_ICON_ZOOM_LEVEL = 10.5;
export const MIN_LABEL_ZOOM_LEVEL = 11.5;
export const MIN_ICON_ZOOM_LEVEL_MODERATE_OR_ABOVE = 9;

export const AQI_COLOR_STOPS: ColorStop[] = [
  { value: AQI_LEVELS_LOWER_BOUNDS.good, color: AQI_LEVELS_COLORS.good },
  {
    value: AQI_LEVELS_LOWER_BOUNDS.moderate,
    color: AQI_LEVELS_COLORS.moderate,
  },
  {
    value: AQI_LEVELS_LOWER_BOUNDS.unhealthySensitive,
    color: AQI_LEVELS_COLORS.unhealthySensitive,
  },
  {
    value: AQI_LEVELS_LOWER_BOUNDS.unhealthy,
    color: AQI_LEVELS_COLORS.unhealthy,
  },
  {
    value: AQI_LEVELS_LOWER_BOUNDS.veryUnhealthy,
    color: AQI_LEVELS_COLORS.veryUnhealthy,
  },
  {
    value: AQI_LEVELS_LOWER_BOUNDS.hazardous,
    color: AQI_LEVELS_COLORS.hazardous,
  },
];

export const AQI_OFFLINE_COLOR = '#999999';
